import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

A.propTypes = {
  href: PropTypes.string.isRequired,
  children: PropTypes.node,
};
export default function A({ href, children, ...props }) {
  return (
    <>
      {href.startsWith('http') ? (
        <a {...props} href={href}>
          {children}
        </a>
      ) : (
        <Link {...props} to={href}>
          {children}
        </Link>
      )}
    </>
  );
}
